﻿import { Component } from '@basic-orange/component';
export default class Slider extends Component {
	constructor(elm, componentId) {
		super(elm, componentId);

		this.$elm = $(elm);
		this.$sliderContainer = this.$elm.find('.Slider-container');
		this.$clusterElm = this.$elm
			.closest('.Slider')
			.find('.Slider-clusterednavigation');

		this.$videoContainers = this.$elm.find('.video-container');
		this.hasYoutubeVideos = this.$videoContainers.length > 0;

		this.loadScriptInterval = null;

		this.breakpointLarge = 1024;

		this.slideCount = this.$clusterElm.data('count');
		this.currentSlide = null;

		this.setEventListeners();
		this.init();

		if (this.hasYoutubeVideos) {
			if (!window.YT) {
				this.loadScriptAndUInitYoutubeSlides();
			} else {
				this.initYoutubeSlides();
			}
		}
	}

	setEventListeners() {
		this.$sliderContainer
			.on('init', this.onInit.bind(this))
			.on('breakpoint', this.onBreakpoint.bind(this))
			.on('beforeChange', this.onBeforeChange.bind(this));

		this.$elm
			.find('.Slider-bottomarrow')
			.on('click', this.onBottomArrowClick.bind(this));
	}

	//Logic
	init() {
		this.$sliderContainer.slick({
			arrows: true,
			prevArrow:
				'<span class="Slider-prev"><i class="fa fa-chevron-left"></i></span>',
			nextArrow:
				'<span class="Slider-next"><i class="fa fa-chevron-right"></i></span>',
			vertical: false,
			autoplay: true,
			autoplaySpeed: 8000,
			draggable: false,
			mobileFirst: true,
			adaptiveHeight: false,
			dots: false,
			infinite: true,
			speed: 1500,
			fade: true,
			appendDots: this.$sliderContainer,
			responsive: [
				{
					breakpoint: this.breakpointLarge, //good example to use design tokens
					settings: {
						// appendArrows: '.Slider-clusterednavigation',
						// appendDots: '.Slider-clusterednavigation',
						dots: true,
						arrows: false,
						// customPaging: function (slider, i) {
						// 	return '<span class="fakeDot">.</span>';
						// },
					},
				},
			],
		});
	}

	loadScriptAndUInitYoutubeSlides() {
	this.loadYoutubeScript();

	this.loadScriptInterval = setInterval(() => {
		if (window.YT && window.YT.loaded) {
			clearInterval(this.loadScriptInterval);

			this.initYoutubeSlides();
		}
	}, 100);
}

	loadYoutubeScript() {
		var tag = document.createElement('script');
		tag.src = 'https://www.youtube.com/iframe_api';
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}

	initYoutubeSlides() {
		this.$videoContainers.each(
			function (i, elm) {
				var $elm = $(elm);
				var $button = $elm.find('.Slider-bigPauseButton');
				var videoid = $elm.data('youtubevideoid');
				var ytContainerId = `player_${this.componentId}_${i}`;

				$elm.append(`<div id="${ytContainerId}"></div>`);

				var player = new YT.Player(ytContainerId, {
					width: 'auto',
					height: 'auto',
					videoId: videoid,
					host: 'https://www.youtube-nocookie.com',
					playerVars: {
						playsinline: 1,
						autoplay: 1,
						mute: 1,
						controls: 0,
						loop: 1,
						playlist: videoid,
						rel: 0,
						modestbranding: 1
					},
					events: {
						onReady: (event) => {
							event.target.playVideo();
						},
						onStateChange: (event) => {
							if (event.data === YT.PlayerState.ENDED) {
								event.target.seekTo(0);
								event.target.playVideo();
							}
						},
					},
				});
				$button.on('click', function () {
					$button.toggleClass('active');
					if ($button.hasClass('active')) {
						player.pauseVideo();
					} else {
						player.playVideo();
					}
				});
			}.bind(this)
		);
	}

	addIndexNumbers(_currentSlide, _currentNumberOfSlides) {
		var currentSlide = ('' + _currentSlide).padStart(2, '0');
		var currentNumberOfSlides = ('' + _currentNumberOfSlides).padStart(2, '0');

		this.$clusterElm.find('.slick-dots').hide();
		this.$clusterElm.find('.Slider-clusterednavigationNumbers').remove();
		this.$clusterElm.append(
			`<div class="Slider-clusterednavigationNumbers">${currentSlide} <span>/ ${currentNumberOfSlides}</span></div>`
		);
	}

	removeIndexNumbers() {
		this.$clusterElm.find('.slick-dots').show();
		this.$clusterElm.find('.Slider-clusterednavigationNumbers').remove();
	}

	toggleIndexNumbers(test, currentSlide, numberOfSlides) {
		if (test) {
			this.addIndexNumbers(currentSlide + 1, numberOfSlides);
		} else {
			this.removeIndexNumbers();
		}
	}

	//Event Handlers

	onInit(event, slick) {
		var w = $(window).width(); //todo: swap out with verge js
		this.toggleIndexNumbers(
			w > this.breakpointLarge,
			slick.currentSlide,
			slick.slideCount
		);

		if (this.slideCount < 2) {
			this.$clusterElm.hide();
		}

		this.currentSlide = 0;
	}

	onBreakpoint(event, slick, breakpoint) {
		this.toggleIndexNumbers(
			breakpoint == this.breakpointLarge,
			slick.currentSlide + 1,
			slick.slideCount
		);
	}

	onBeforeChange(event, slick, currentSlide, nextSlide) {
		var w = $(window).width(); //todo: swap out with verge js
		this.toggleIndexNumbers(
			w > this.breakpointLarge,
			nextSlide,
			slick.slideCount
		);

		this.currentSlide = nextSlide;
	}

	onBottomArrowClick(event) {
		event.preventDefault();
		this.$elm
			.find(`.sliderItem[data-index="${this.currentSlide}"] a`)
			.trigger('click');
	}
}
